import { documentFieldTypeApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';

export const GET_DOCUMENT_FIELD_TYPES = 'GET_DOCUMENT_FIELD_TYPES';
export const CREATE_DOCUMENT_FIELD_TYPES = 'CREATE_DOCUMENT_FIELD_TYPES';
export const DELETE_DOCUMENT_FIELD_TYPES = 'DELETE_DOCUMENT_FIELD_TYPES';
export const EDIT_DOCUMENT_FIELD_TYPES = 'EDIT_DOCUMENT_FIELD_TYPES';
export const RESET_DOCUMENT_FIELD_TYPES = 'RESET_DOCUMENT_FIELD_TYPES';

const documentFieldTypes = new schema.Entity(
  'documentFieldTypes',
  {},
  {
    idAttribute: 'id',
    processStrategy: entity => {
      return { ...entity, parentId: entity.parentId || null };
    },
  },
);

export const getDocumentFieldTypesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await documentFieldTypeApi.getDocumentFieldTypes();

  return dispatch({
    type: GET_DOCUMENT_FIELD_TYPES,
    payload: normalize(data, [documentFieldTypes]).entities,
  });
});

export const postDocumentFieldTypesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await documentFieldTypeApi.createDocumentFieldType(params);

  data.parentId = data.parentId || null;

  dispatch({
    type: CREATE_DOCUMENT_FIELD_TYPES,
    payload: data,
  });

  return data;
});

export const editDocumentFieldTypesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await documentFieldTypeApi.editDocumentFieldType(params);

  data.parentId = data.parentId || null;

  return dispatch({
    type: EDIT_DOCUMENT_FIELD_TYPES,
    payload: data,
  });
});

export const deleteDocumentFieldTypesAction = catchAsyncActionError(params => async dispatch => {
  await documentFieldTypeApi.deleteDocumentFieldType(params);

  return dispatch({
    type: DELETE_DOCUMENT_FIELD_TYPES,
    payload: params.id,
  });
});
